import React, { useContext } from "react";
import { TextField, PrimaryButton } from "@fluentui/react";
import MobileInput from "../../../components/MobileInput";
import { t } from "i18next";
import {
  ACTIONS,
  AuthRoutes,
  USERTYPES,
  TOAST_TYPE,
} from "../../../constants/Constants";
import userContext from "../../../context/users/UserContext";
import { P } from "@kitware/vtk.js/Common/Core/Math/index";

const TechnicianContact = ({
  index,
  contact,
  handleTechnicianContactChange,
  handleBlur,
  touched,
  errors,
  handleInputValidationMobile,
  removeTechnicianContact,
  state,
}) => {
  const { roles } = useContext(userContext);

  return (
    <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
      <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl4">
        <TextField
          name={`technicianContactList[${index}].name`}
          placeholder={t("user.name")}
          label={t("user.name")}
          onChange={(e) =>
            handleTechnicianContactChange(index, "name", e.target.value)
          }
          value={contact.name}
          onBlur={handleBlur}
          errorMessage={
            touched?.technicianContactList &&
            touched?.technicianContactList[index] &&
            errors?.technicianContactList &&
            errors?.technicianContactList[index] &&
            errors?.technicianContactList[index].name
          }
        />
      </div>
      <div className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl4">
        <MobileInput
          name={`technicianContactList[${index}].mobile`}
          placeholder={t("user.mobile")}
          value={contact.mobile}
          label={t("user.mobile")}
          onChangeCustom={(value, data) => {
            handleInputValidationMobile(value, data);
            contact.mobile = "+" + value;
          }}
          touched={touched.mobile}
        />
      </div>

      <div
        className="form-field ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl4"
        style={{ marginTop: "30px" }}
      >
        <div style={{ display: "flex", justifyContent: "start" }}>
         
            <div style={{ marginRight: "20px", marginTop : "5px" }}>
              <input
                type="checkbox"
                name={`technicianContactList[${index}].isPrimaryContact`}
                title="Primary contact"
                value={1}
                checked={contact.isPrimaryContact === 1}
                onChange={(event) =>{
                  let selected = event.target.checked == true ? 1 : 0;
                  handleTechnicianContactChange(index, "isPrimaryContact", selected);
                  }
                }
              />
            </div>
          

          <PrimaryButton
            text="Delete"
            onClick={() => removeTechnicianContact(index)}
          />
          {contact.isPrimaryContact === 1 && (
            <div style={{ marginLeft: "10px" }}>
              <p>Primary Contact</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TechnicianContact;
